import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, loadOptions, note, editable }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    loadOptions,
    note,
    editable
  }))
 )
}

export const fields: any = {
  centralizedQandAs: mapFields(
    drilldownData["centralizedQandAs"]
  ),
  centralizedFaqsCategories: mapFields(drilldownData["centralizedFaqsCategories"]),
  centralizedKeyInfoBanner: mapFields(drilldownData["centralizedKeyInfoBanner"])
};
